module.exports = __webpack_public_path__ + "img/Ecole.df715534.jpg";